<template>
  <div>
    <h2>我报名的活动</h2>
    <a-divider></a-divider>
    <div class="pannel">
      <a-button type="danger" @click="toOrder()" icon="right-circle">查看我的订单</a-button>
      <a-divider type="vertical"></a-divider>

<!--       
      <a-button v-if="canDeviceTest" type="primary" @click="envCheck()" icon="camera" id="envCheckBtn">设备检测</a-button>
      <a-tooltip v-else title="考前设备检测已关闭，请进入模拟练习进行完整步骤检测">
        <a-button disabled icon="camera" id="envCheckBtn">设备检测</a-button>
      </a-tooltip> -->

      <a-button @click="searchUsernameVisible=true" type="primary" style="float:right;">查询账号</a-button>
      <a-list :dataSource="dataSource" :pagination="pagination" :locale="{emptyText: '暂无报名的活动'}">
        <a-list-item slot="renderItem" slot-scope="item">
          <a-card class="item-card" >
            <a-row :gutter="24">
              <a-col :sm="8" :xs="24">
                <div class="img-zoom">
                  <img class="cover" :src="item.categorys[0].eventCover_url" alt="" />
                </div>
              </a-col>
              <a-col :sm="16" :xs="24">
                <h2>{{item.categorys[0].eventName}} </h2>
                <p>报名开始：{{item.categorys[0].eventBegin}}</p>
                <p>报名结束： {{item.categorys[0].eventEnd}}</p>
              </a-col>
              <a-col :sm="24" :xs="24">
                <a-divider>报名赛项</a-divider>
                <div v-for="(c,i) in item.categorys" :key="i">
                  <p>
                    <a-tag>{{c.eventType_dictText}}</a-tag>
                    <a-tag color="red" v-if="c.applyStatus==0">未支付</a-tag>
                    <a-tag color="red" v-if="c.applyStatus==-1">已退费</a-tag>
                    <a-divider type="vertical"></a-divider>
                    <span v-if="c.myEventCategoryPid_dictText">赛项：{{c.myEventCategoryPid_dictText}} </span>
                    <a-divider type="vertical"></a-divider>
                    <span v-if="c.myEventCategory_dictText">组别：{{c.myEventCategory_dictText}}</span>
                  </p>
                  
                  <p v-if="c.examBegin">正式考试时间：{{c.examBegin}}</p>

                  <div v-if="c.applyStatus >= 0" :sm="4" :xs="24" class="event-opts">
                    <!-- <a-button type="dashed" @click="toEventDetail(c)">活动详情</a-button> -->
                    <a-button @click="showApplyEvent(c)">报名信息</a-button>
                    <a-button v-if="c.ticketUrl" type="dashed" @click="download(c.ticketUrl)">准考证</a-button>
                    <a-button v-if="c.applyStatus==1 && c.takePartType==1" type="primary" @click="showSubmitWork(c)">{{c.worksVOS.length>0?'查看':'资料提交'}}</a-button>
                    <a-button v-if="c.applyStatus==1 && c.takePartType==0 && c.examStatus > 0" type="primary" :disabled="c.examStatus!=1" @click="toPaper(c, true)">{{c.examStatus==1?'模拟练习':'模拟练习已结束'}}</a-button>
                    <a-button v-if="c.applyStatus==1 && c.takePartType==0 && c.examStatus > 0" type="danger" :disabled="c.examStatus!=2" @click="toPaper(c, false)">去测评</a-button>
                    <a-button v-if="c.applyStatus==1 && c.canMissingApply" @click="toMissingApply(c)">缺考登记</a-button>
                    <a-button v-if="c.canQueryScore" @click="toScore(c.eventApplyId)">测评成绩</a-button>
                    <a-button v-if="canQueryCert(c)" @click="toCert(c.certId)">测评证书</a-button>
                    <a-button v-if="c.applyStatus==0 && c.isEventOpen" @click="toPay(c)" type="danger">支付</a-button>
                  </div>
                  <a-divider></a-divider>
                </div>
              </a-col>
              
            </a-row>
          </a-card>
        </a-list-item>
      </a-list>
    </div>
    <!-- <ExamEnvCheckModal ref="envCheck"/> -->
    <EventPay ref="eventPay" @payOk="payOk"/>
    <EventApplyModal ref="applyModal"/>
    <SubmitWorkModal ref="submitModal" @ok="submitOk"/>
    <MissingExamApplyModal ref="missingExamModal"/>
    <a-modal title="查询账号" 
      :width="400" 
      :visible="searchUsernameVisible" 
      :maskClosable="false" 
      @ok="searchUsername"
      okText="查询"
      @cancel="searchUsernameVisible = false">
        <p>请输入身份证号查询已经报名的账号。</p>
        <a-input placeholder="请输入身份证号" v-model="searchIdcard"></a-input>
        <a-divider></a-divider>
        <div v-if="searchResult">
          <p>
            查询结果：
          </p>
          <p>{{searchResult}}</p>
        </div>
        
    </a-modal>
  </div>
</template>

<script>

import Vue from 'vue'
import "@/assets/less/animation.css";
import { getAction, postAction } from "@/api/manage";
import { USER_INFO } from '@/store/mutation-types'
import EventApplyModal from "../modal/EventApplyModal"
import SubmitWorkModal from "../modal/SubmitWorkModal"
import MissingExamApplyModal from "../modal/MissingExamApplyModal"
// import ExamEnvCheckModal from "@/components/exam/ExamEnvCheckModal"
import EventPay from "../modal/EventPay"
import {filterMultiDictText} from '@/components/jeecg/JDictSelectUtil'
import { loadCategoryData } from '@/api/api'
export default {
  name: "Event",
  components:{
    EventApplyModal,
    SubmitWorkModal,
    MissingExamApplyModal,
    // ExamEnvCheckModal,
    EventPay
  },
  data() {
    return {
      userInfo: {},
      dataSource: [],
      dictOptions: [],
      pagination: {
        onChange: (page) => {
          console.log(page);
        },
        pageSize: 6,
      },
      searchUsernameVisible: false,
      searchIdcard: '',
      searchResult: '',
      canDeviceTest: false,
    };
  },
  created() {
    // loadCategoryData({code:"A05"}).then((res) => {
    //   if (res.success) {
    //     this.$set(this.dictOptions, 'eventCategory', res.result)
    //   }
    // })
    this.getMyApplyEvent()
  },
  mounted(){
    this.userInfo = Vue.ls.get(USER_INFO);
    // if(!this.userInfo['examCheckStatus']){
      //this.$refs.envCheck.open()
    // }
    let that = this
    document.addEventListener("visibilitychange", function () {
      if (!document.hidden) {  
        // 处于当前页面
        that.getMyApplyEvent()
      }else{
        // 页面切出,不处于当前页面
      }
    });
  },
  methods:{
    searchUsername(){
      if(this.searchIdcard == ''){
        this.$message.info('请输入身份证号码')
        return
      }
      getAction("/aice/searchUsername?idcard="+this.searchIdcard).then(res=>{
        if(res.success){
          this.searchResult = res.message
        }
      })
    },
    // getDictValue(text){
    //   return filterMultiDictText(this.dictOptions['eventCategory'], text)
    // },
    getMyApplyEvent(){
      getAction("/teaching/teachingEventApply/myApply").then((res) => {
        if (res.success) {
          let eventGroup = []

          for(let i=0; i<res.result.length; i++){
            let findIndex = -1
            for(let j=0; j<eventGroup.length; j++){
              if(eventGroup[j].eventId == res.result[i].eventId){
                findIndex = j
              }
            }
            if(findIndex > -1){
              eventGroup[findIndex].categorys.push(res.result[i])
            }else{
              eventGroup.push({
                eventId: res.result[i].eventId,
                categorys: [
                  res.result[i]
                ]
              })
            }
          }

          console.log(eventGroup);
          

          // this.dataSource = res.result
          this.dataSource =eventGroup
          
        }
      });
    },
    toEventDetail(item){
      let route = this.$router.resolve({
        path: "/event/detail",
        query: {
          id: item.eventId,
        },
      });
      window.open(route.href, '_blank');
    },
    download(url){
      window.open(url + "?t="+new Date().getTime())
    },
    toOrder(){
      this.$router.push({path: '/user/order'})
    },
    toPay(applyInfo){
        console.log(applyInfo);
        getAction("/teaching/teachingOrder/getUnPayOrderInfoByEventApply?eventApplyId="+applyInfo.eventApplyId).then(res=>{
          if(res.success){
            this.$refs.eventPay.open(res.result)
          }else{
            this.$message.error(res.message)
          }
        })
    },
    // envCheck(){
    //   this.$refs.envCheck.open()
    // },
    payOk(){
      this.getMyApplyEvent()
    },
    submitOk(){
      this.getMyApplyEvent()
    },
    showApplyEvent(applyInfo){
      this.$refs.applyModal.open(applyInfo.eventId, applyInfo.myEventCategory)
    },
    showSubmitWork(info){
      if(info.takePartType == 2){
        this.$success({
          title: "提示",
          content: (
            <div>
              <p>线下活动报名成功后直接提示凭证件前往！</p>
            </div>
          ),
        });
      }else{
        this.$refs.submitModal.open(info)
      }
    },
    toPaper(item, check){
      let that = this
      // this.userInfo = Vue.ls.get(USER_INFO);
      // if(!this.userInfo['examCheckStatus'] && check){
      //   this.$confirm({
      //     title: "您还没有进行环境检测",
      //     content: "建议您先进行环境检测后参加测评，否则可能会影响考评结果。",
      //     onOk() {
      //       that.$refs.envCheck.open()
      //     },
      //     okText: '去环境检测',
      //     onCancel() {
      //       that.toPaper0(item)
      //     },
      //     cancelText: '跳过环境检测'
      //   });
      // }else{
      //   that.toPaper0(item)
      // }
      that.toPaper0(item)
    },
    toPaper0(item){
      let route = this.$router.resolve({
        path: "/examine",
        query: {
           eaid: item.eventApplyId,
          examStatus: item.examStatus,
          envTest: item.canDeviceTest,
          // category: item.myEventCategory_dictText,
          qrCodeUrl: (item.qrcodeFileUrl && item.qrcodeFileUrl != 'null') ? btoa(item.qrcodeFileUrl) : '',
          ticketUrl: (item.ticketUrl && item.ticketUrl != 'null') ? btoa(item.ticketUrl) : ''
        },
      });
      window.open(route.href, '_blank');
    },
    toScore(eventApplyId){
      window.open("/cert/score.html?id="+eventApplyId)
    },
    toMissingApply(event){
      this.$refs.missingExamModal.open(event)
    },
    canQueryCert(item){
      let now = new Date().getTime()
      let startTime = item.queryScoreBegin?new Date(item.queryScoreBegin).getTime():0
      let endTime = item.queryCertEnd?new Date(item.queryCertEnd).getTime():0
      if(item.certId && item.certId!='-1' && item.queryScoreBegin && startTime < now && endTime > now ){
        return true
      }else{
        return false
      }
    },
    toCert(certId){
      window.open("/cert/query.html?id="+certId)
    },
  }
};
</script>

<style lang="less" scoped>
.pannel{
  .item-card{
    .cover{
      width: 100%;
    }
    .event-opts{
      .ant-btn{
        margin: 8px 4px;
      }
      
    }
  }

}

</style>